import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Common/Button";
import "./style.scss";

interface Props {
	handleGoNext: Function;
}

const StudentOnboardingFinal = ({ handleGoNext }) => {
	const { t } = useTranslation();

	return (
		<div className="studentOnboardingFinal dark-bg">
			<div className="container">
				<div className="card p-5 mt-5">
					<h2 className="title mb-4 text-center">{t("student_onboarding_final_title")}</h2>
					<p className="mb-5 text-center">{t("student_onboarding_final_subtitle")}</p>
					<Button onClick={handleGoNext} filled backgroundColor="#3392E8" borderColor="#3392E8">
						{t("student_onboarding_final_button")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default StudentOnboardingFinal;
